import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../apiUrls';

const mutationUpdatePosTerminalLabels = (onSuccess, onError) => {
    return {
        mutationFn: ({ posTerminalId, posTerminalLabels }) => {
            return client.put(replaceParameters(POS_TERMINALS.DETAILS.url, { posTerminalId }), posTerminalLabels);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdatePosTerminalLabels;